import { createAction, props } from '@ngrx/store';

import {
  BuildingItem,
  BuildingsList,
  LastPageStateBuildings,
  RoomItem,
} from '@store/buildings/buildinngs.state';

export const loadBuildings = createAction('[Buildings] Get');

export const loadBuildingsSuccess = createAction(
  '[Buildings] Load Buildings Success',
  props<{ list: BuildingsList }>(),
);

export const loadBuildingsFailure = createAction(
  '[Buildings] Load Buildings Failure',
  props<{ error: string }>(),
);

export const setLastPageStateBuildings = createAction(
  '[Buildings] Set last page state',
  props<{ newPageState: Partial<LastPageStateBuildings> }>(),
);

export const addBuilding = createAction(
  '[Buildings] Add Buildings',
  props<{ building: BuildingItem }>(),
);

export const updateBuilding = createAction(
  '[Buildings] Update Buildings',
  props<{ id: number; changes: Partial<BuildingItem> }>(),
);

export const deleteBuilding = createAction('[Buildings] Delete Buildings', props<{ id: string }>());

export const updateRoom = createAction(
  '[Buildings] Update room',
  props<{ changes: Partial<RoomItem> }>(),
);

export const addRoom = createAction(
  '[Buildings] Add room',
  props<{ changes: Partial<RoomItem> }>(),
);

export const deleteRoom = createAction(
  '[Buildings] Delete room',
  props<{ id: number; buildingId: number }>(),
);
